import { useState, useEffect, useCallback } from "react";
import Sidebar from "../../sidebar/sidebar";
import TopBar from "../../topbar/TopBar";
import { getfielsApi, registerSubmitApi } from "./registerfield-api";
import { Col, Row, Toast, ToastContainer } from "react-bootstrap";

const visitorSteps = ["Visitor", "Vehicle"];

const Registerfields = () => {
  const [activeTab, setActiveTab] = useState("Visitor");
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);

  const [fieldOptions, setfieldOptions] = useState([]);
  const handleToggle = (option) => {
    const updatedFields = fieldOptions.map((field) =>
      field.field_name === option.field_name
        ? { ...field, enabled: !field.enabled }
        : field
    );

    setfieldOptions(updatedFields);
  };
  const handleMandToggle = (option) => {
    const updatedFields = fieldOptions.map((field) =>
      field.field_name === option.field_name
        ? { ...field, mandatory: !field.mandatory }
        : field
    );

    setfieldOptions(updatedFields);
  };



  const getFields = async (value) => {
    try {
      const response = await getfielsApi(value);
      console.log("fields");
      console.log(response);
      if (response.success === true) {
        setfieldOptions(response.fields)
      }

    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const submitform = async (value) => {
    const bodydata = { "page": activeTab, "fields": fieldOptions };
    const response = await registerSubmitApi(bodydata);
    console.log("response");
    console.log(response);

    if (response.status === true) {
      setSnackbarMessage(response.message);
      setSnackbarStatus(response.status);
      handleSnackbarShow();
      getFields(activeTab)

    }
  }
  useEffect(() => {
    getFields(activeTab)

  }, []);

  return (
    <div style={{ fontFamily: "Epilogue" }}>
      <div>
        <TopBar />
      </div>
      <div style={{ display: "flex" }}>
        <div>
          <Sidebar activeMenu={"Register Fields"} />
        </div>
        <div style={{ display: "flex", flexDirection: "column", width: "100%", padding: "20px", backgroundColor: "#FFFFFF" }}>
          {/* <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: "32px", marginBottom: "28px" }}>
            <div style={{ width: "28%", border: "1px dashed #E5E5E5", height: "0px" }}></div>
            <div style={{ fontWeight: "400", fontSize: "13px", color: "#8790A1" }}>Set up your organization with these master settings and manage them seamlessly from here.</div>
            <div style={{ width: "28%", border: "1px dashed #E5E5E5", height: "0px" }}></div>
          </div> */}
          <Row className="my-4 align-items-center">
            <Col>
              <div style={{ borderTop: "1px dashed #E5E5E5", width: "100%" }}></div>
            </Col>

            <Col >
              <div
                style={{
                  fontWeight: 400,
                  fontSize: 13,
                  color: "#8790A1",
                  whiteSpace: "nowrap", // keep text on a single line
                }}
              >
                Set up your organization with these master settings and manage them seamlessly from here.
              </div>
            </Col>

            <Col>
              <div style={{ borderTop: "1px dashed #E5E5E5", width: "100%" }}></div>
            </Col>
          </Row>


          <div style={{ display: "flex", justifyContent: "space-between", padding: "16", }}>
            <div>
              <div style={{ fontWeight: "700", fontSize: "20px", color: "#172b4d" }}>Register Fields ({visitorSteps.length})</div>
              <div>
                <div style={{ display: "flex", alignItems: "center", borderLeft: "1px dashed #626F86" }}>
                  {/* <div style={{ border: "1px dashed #626F86", width: "20px", height: "0px", visibility: "hidden" }}></div> */}
                  <div style={{ borderRadius: "8px", visibility: "hidden" }}>Visitor gate-in</div>
                </div>
                {visitorSteps.map((label) => (
                  <div

                    key={label} style={{ display: "flex", alignItems: "center", borderLeft: "1px dashed #626F86", cursor: "pointer" }} onClick={() => {
                      setActiveTab(label);
                      getFields(label); // optional second action
                    }}
                  >
                    <div style={{ border: "1px dashed #626F86", width: "20px", height: "0px" }}></div>
                    <div
                      style={{
                        borderRadius: "8px",
                        padding: "10px 8px 10px 12px",
                        backgroundColor: activeTab === label ? "#F3FFF8" : "",
                        border: activeTab === label ? "1px dashed #2c8c53" : "",
                        color: activeTab === label ? "#2c8c53" : "#000",
                        transition: "all 0.2s ease-in-out",
                        width: "100%",
                      }}
                    >
                      {label}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div style={{ borderRadius: "16px", padding: "20px 16px 16px 16px", backgroundColor: "#F8F8F8", display: "flex", flexDirection: "column", gap: "12px", width: "75%" }}>
              <div style={{ marginTop: "6px", fontWeight: "700", fontSize: "14px", color: "#2c8c53", textAlign: "center" }}>{activeTab.toUpperCase()}</div>

              <div>
                <div style={{ marginBottom: "12px", fontWeight: "600", fontSize: "13px", color: "#8790A1" }}>Configurations</div>

                <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                  {fieldOptions.map((option) => (
                    <div
                      key={option.field_name}
                      style={{
                        backgroundColor: "#FFFFFF",
                        borderRadius: "6px",
                        padding: "16px",
                        display: "flex",
                        flexDirection: "column",
                        gap: "24px",
                      }}
                    >
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <div style={{ fontWeight: "600", fontSize: "14px", color: "#174b4d" }}>{option.field_name}</div>

                        <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
                          {option.enabled && (
                            <>
                              <div
                                style={{
                                  paddingLeft: "12px",
                                  paddingRight: "12px",
                                  borderRadius: "10px",
                                  backgroundColor: "#F8F8F8",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <div style={{ padding: "4px", marginRight: "8px" }}>
                                  <input
                                    type="checkbox"
                                    checked={option.mandatory}
                                    onChange={() => handleMandToggle(option)} style={{
                                      width: "20px",       // width
                                      height: "20px",      // height
                                      accentColor: "#2C8C53", // color (modern browsers)
                                      cursor: "pointer",
                                      marginTop: "3px", //
                                      borderRadius: "6px",
                                      transform: "scale(0.8)",
                                      // appearance: "none",        // ✅ remove native styles
                                      // // WebkitAppearance: "none",  // ✅ Safari
                                      outline: "1px solid #ccc", // optional border
                                    }}
                                  />
                                </div>
                                <div
                                  onClick={() => handleMandToggle(option)}
                                  style={{
                                    fontWeight: "500",
                                    fontSize: "13.5px", cursor: "pointer",
                                    color: "#172b4d",
                                  }}
                                >
                                  Mandatory
                                </div>
                              </div>
                              <div
                                style={{
                                  width: "1px",
                                  height: "28px",
                                  backgroundColor: "#E5E5E5",
                                }}
                              ></div>
                            </>
                          )}

                          <label
                            style={{
                              display: "inline-block",
                              position: "relative",
                              width: "40px",
                              height: "24px",
                            }}
                          >
                            <input type="checkbox" checked={option.enabled} onChange={() => handleToggle(option)} style={{ opacity: 0, width: 0, height: 0 }} />
                            <span
                              style={{
                                position: "absolute",
                                cursor: "pointer",
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                backgroundColor: option.enabled ? "#2c8c53" : "#ccc",
                                transition: ".4s",
                                borderRadius: "24px",
                              }}
                            ></span>
                            <span
                              style={{
                                position: "absolute",
                                height: "18px",
                                width: "18px",
                                left: option.enabled ? "20px" : "4px",
                                bottom: "3px",
                                backgroundColor: "white",
                                transition: ".4s",
                                borderRadius: "50%",
                              }}
                            ></span>
                          </label>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <div style={{ marginTop: '20px' }}>
                  <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <button
                      onClick={() => submitform()}
                      style={{
                        borderRadius: "100px",
                        border: "1px solid #E5E5E5",
                        padding: "10px 28px",
                        backgroundColor: "#2C8C53",
                        fontWeight: "700",
                        fontSize: "14px",
                        width: "160px",
                        color: "#FFFFFF",
                        cursor: "pointer"
                      }}
                    >
                      Update
                    </button>
                  </div></div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer position="top-end">
          <Toast
            className="d-inline-block m-1"
            bg={snackbarStatus === true ? "success" : "danger"}
            show={showSnackbar}
            onClose={handleSnackbarClose}
            delay={3000}
            autohide
          >
            <Toast.Body style={{ color: "#ffffff" }}>
              {snackbarMessage}
            </Toast.Body>
          </Toast>
        </ToastContainer>
      </div>
    </div>
  );
};

export default Registerfields;
